import { useEffect } from 'react'
import { PageHeader } from '@/components/PageHeader'
import { useAnalyticsView } from '@/features/amplitude'
import { UpriseIframe } from '../UpriseIframe'

export const FinancialAdvisoryGoals = () => {
  const pageView = useAnalyticsView()
  useEffect(() => {
    pageView('advisory goals panel')
  }, [pageView])

  return (
    <>
      <PageHeader header="Financial Advisory" />
      <UpriseIframe page="goals" />
    </>
  )
}
